import { render, staticRenderFns } from "./LiveReplyComment.vue?vue&type=template&id=3fd133b4&scoped=true&"
import script from "./LiveReplyComment.vue?vue&type=script&lang=ts&"
export * from "./LiveReplyComment.vue?vue&type=script&lang=ts&"
import style0 from "./LiveReplyComment.vue?vue&type=style&index=0&id=3fd133b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd133b4",
  null
  
)

export default component.exports